package settings.syndrome.containers


import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.api.clients.SyndromeApiClient
import com.jingfangpai.api.clients.SyndromeIndicationApiClient
import com.jingfangpai.api.clients.SyndromeIndicationSignSymptomApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.Syndrome
import com.jingfangpai.common.orm.mapping.SyndromeIndication
import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptom
import com.jingfangpai.syndrome.model.SyndromeDetail
import com.jingfangpai.syndrome.model.SyndromeIndicationDetail
import react.*
import react.dom.div
import setTitle
import settings.syndrome.components.SyndromeSetting

external interface SyndromeSettingPageProps : RProps {

}

data class SyndromeSettingPageContextData(
    var getListInDetail: (okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.List<SyndromeDetail>>) -> Unit, errorCallback:(Throwable)->Unit)->Unit,
    var saveSyndrome:(syndrome:Syndrome,okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.Syndrome>) -> Unit,errorCallback:(Throwable)->Unit)->Unit,
    var saveSyndromeIndication:(syndromeIndication: SyndromeIndication, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SyndromeIndication>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getSignSymptomOptions:(okCallback: (result: ApiResponse<Array<CascadedOption<String>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit,
    var saveSyndromeIndicationSignSymptom:(syndromeIndicationSignSymptom: SyndromeIndicationSignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SyndromeIndicationSignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var findAllCharacteristicsGroupBySymptomId:(okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.collections.Map<kotlin.String, kotlin.collections.List<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveCharacteristic:(syndromeIndicationSignSymptomCharacteristic:com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
    )

val SyndromeSettingPageContext = createContext(SyndromeSettingPageContextData(SyndromeApiClient::getListInDetail,SyndromeApiClient::save,SyndromeIndicationApiClient::save,
    SignSymptomApiClient::getOptions, SyndromeIndicationSignSymptomApiClient::save,SignSymptomApiClient::findAllCharacteristicsGroupBySymptomId,SyndromeIndicationSignSymptomApiClient::saveCharacteristic))

val SyndromeSettingPageProvider = functionalComponent<SyndromeSettingPageProps> { props ->

    setTitle("病证列表")

    useEffectOnce { }

    SyndromeSettingPageContext.Provider(SyndromeSettingPageContextData(SyndromeApiClient::getListInDetail,SyndromeApiClient::save,SyndromeIndicationApiClient::save,
        SignSymptomApiClient::getOptions,
        SyndromeIndicationSignSymptomApiClient::save,SignSymptomApiClient::findAllCharacteristicsGroupBySymptomId,SyndromeIndicationSignSymptomApiClient::saveCharacteristic)) {
        div("SyndromeSetting-page") {
            child(SyndromeSetting) {

            }
        }
    }
}